import Vue from 'vue'
// GeneralViews
import NotFound from 'src/pages/NotFoundPage.vue'
import Login from 'src/pages/Login.vue'
import ChangePassword from 'src/pages/ChangePassword.vue'
// Dashboard pages
import DashboardLayout from 'src/pages/admin/.Layout/DashboardLayout.vue'
import HomeTop from 'src/pages/admin/home/HomeTop.vue'
import AffiliateAccounts from 'src/pages/admin/AffiliateAccounts.vue'
import IncentifyerAccounts from 'src/pages/admin/IncentifyerAccounts.vue'
// import Invoices from 'src/pages/admin/Invoices.vue'
import Users from 'src/pages/admin/Users.vue'
import AffiliateCompanies from 'src/pages/admin/AffiliateCompanies.vue'
import PaymentCards from 'src/pages/admin/PaymentCards.vue'
import Payouts from 'src/pages/admin/Payouts.vue'
import Leads from 'src/pages/admin/Leads.vue'
import Version from 'src/pages/Version.vue'
//const Setup = () => import('src/pages/admin/Setup.vue')

// other
import store from '@/store/store'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'

Vue.use(VueRouter)

const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/admin/users'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/changePassword',
      name: 'Change Password',
      meta: { requiresAuth: true },
      component: ChangePassword
    },
    {
      path: '/admin',
      meta: { requiresAuth: true },
      component: DashboardLayout,
      redirect: '/admin/users',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: HomeTop,
        },
        {
          path: 'affiliateAccounts',
          name: 'Affiliate Accounts',
          component: AffiliateAccounts
        },
        {
          path: 'incentifyerAccounts',
          name: 'Incentifyer Accounts',
          component: IncentifyerAccounts
        },
        // {
        //   path: 'invoices',
        //   name: 'Invoices',
        //   component: Invoices
        // },
        {
          path: 'users',
          name: 'Users',
          component: Users
        },
        {
          path: 'affiliateCompanies',
          name: 'Affiliate Companies',
          component: AffiliateCompanies
        },
        {
          path: 'paymentCards',
          name: 'Payment Cards',
          component: PaymentCards
        },
        {
          path: 'payouts',
          name: 'Payouts',
          component: Payouts
        },
        {
          path: 'leads',
          name: 'Leads',
          component: Leads
        },
      ]
    },
    {
      path: '/404',
      name: '404',
      props: true,
      component: NotFound
    },
    {
      path: '*/v(ersion)?',
      name: 'App Version',
      meta: { requiresAuth: true },
      component: Version
    },
    {
      path: '*',
      redirect: { name: '404', params: { resourceType: 'page' } }
    }
  ]
})




// we check session validity before entering any secure page
router.beforeEach (async (to, from, next) => {
  console.log('beforeEach(): route requested = ', to.fullPath.toString())
  NProgress.start()
  NProgress.set(0.4)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // For protected routes, we make sure there is a token in the session
    const session = store.getters.session
    console.log('session: ', session)
    if (!!session && !!session.token) {
      // console.log('1')
      try { // we make sure the token is still valid
        // console.log('1.1')
        await store.dispatch('setToken', session.token)
        const isTokenValid = await store.dispatch('isSessionValid')
        if (isTokenValid) {
          console.log('> router.beforeEach(): token valid')
          next()
        }
        else {
          console.log('> router.beforeEach(): token invalid')
          store.commit('CLEAR_SESSION')
          NProgress.done()
          next('/login')
        }
        
      }
      catch (error) { // we redirect to login if there was an issue
        store.commit('CLEAR_SESSION')
        NProgress.done()
        next('/login')
      }
    }
    else {
      console.log('2')
      // if (from.fullPath == to.fullPath) {
        NProgress.done()
      // }
      next('/login')
    }
  }
  else { // Unprotected routes
    // console.log('3')
    next()
  }
})

router.afterEach (() => {
  console.log('afterEach():')
  NProgress.done()
})

export default router
